// Tool Component Registry - Maps tool slugs to their React components
import DefaultToolComponent from '../components/tools/DefaultToolComponent';
import TextCounterTool from '../components/tools/TextCounterTool';
import JsonFormatterTool from '../components/tools/JsonFormatterTool';
import ColorPickerTool from '../components/tools/ColorPickerTool';
import PasswordGeneratorTool from '../components/tools/PasswordGeneratorTool';
import UuidGeneratorTool from '../components/tools/UuidGeneratorTool';
import Base64Tool from '../components/tools/Base64Tool';
import UrlEncoderTool from '../components/tools/UrlEncoderTool';
import HtmlMinifierTool from '../components/tools/HtmlMinifierTool';
import MarkdownToHtmlTool from '../components/tools/MarkdownToHtmlTool';
import SlugGeneratorTool from '../components/tools/SlugGeneratorTool';
import LoremIpsumTool from '../components/tools/LoremIpsumTool';
import HashGeneratorTool from '../components/tools/HashGeneratorTool';
import CaseConverterTool from '../components/tools/CaseConverterTool';
import TimestampConverterTool from '../components/tools/TimestampConverterTool';
import RegexTesterTool from '../components/tools/RegexTesterTool';
import CssMinifierTool from '../components/tools/CssMinifierTool';
import HtmlEncoderTool from '../components/tools/HtmlEncoderTool';
import DiffCheckerTool from '../components/tools/DiffCheckerTool';
import PlaceholderImageTool from '../components/tools/PlaceholderImageTool';
import NumberFormatterTool from '../components/tools/NumberFormatterTool';
import JsMinifierTool from '../components/tools/JsMinifierTool';
import JsonValidatorTool from '../components/tools/JsonValidatorTool';
import MetaTagGeneratorTool from '../components/tools/MetaTagGeneratorTool';

// New tools
import WordCounterTool from '../components/tools/WordCounterTool';
import CharacterCounterTool from '../components/tools/CharacterCounterTool';
import TextReverserTool from '../components/tools/TextReverserTool';
import TextRepeaterTool from '../components/tools/TextRepeaterTool';
import RemoveDuplicateLinesTool from '../components/tools/RemoveDuplicateLinesTool';
import SortLinesTool from '../components/tools/SortLinesTool';
import TextToBinaryTool from '../components/tools/TextToBinaryTool';
import FindAndReplaceTool from '../components/tools/FindAndReplaceTool';
import ExtractEmailsTool from '../components/tools/ExtractEmailsTool';
import ExtractUrlsTool from '../components/tools/ExtractUrlsTool';
import TextCleanerTool from '../components/tools/TextCleanerTool';
import JsonToCsvTool from '../components/tools/JsonToCsvTool';
import CsvToJsonTool from '../components/tools/CsvToJsonTool';
import JwtDecoderTool from '../components/tools/JwtDecoderTool';
import HtmlToJsxTool from '../components/tools/HtmlToJsxTool';
import SqlFormatterTool from '../components/tools/SqlFormatterTool';
import CronParserTool from '../components/tools/CronParserTool';
import RobotsTxtGeneratorTool from '../components/tools/RobotsTxtGeneratorTool';
import SitemapGeneratorTool from '../components/tools/SitemapGeneratorTool';
import KeywordDensityTool from '../components/tools/KeywordDensityTool';
import QrCodeGeneratorTool from '../components/tools/QrCodeGeneratorTool';
import RandomNumberTool from '../components/tools/RandomNumberTool';
import RandomStringTool from '../components/tools/RandomStringTool';
import HexToRgbTool from '../components/tools/HexToRgbTool';
import PxToRemTool from '../components/tools/PxToRemTool';
import TemperatureConverterTool from '../components/tools/TemperatureConverterTool';
import BytesConverterTool from '../components/tools/BytesConverterTool';
import MorseCodeTool from '../components/tools/MorseCodeTool';
import RomanNumeralsTool from '../components/tools/RomanNumeralsTool';

// Stage 1 Tools (40 new tools)
import LineCounterTool from '../components/tools/stage1/LineCounterTool';
import RemoveHtmlTagsTool from '../components/tools/stage1/RemoveHtmlTagsTool';
import ReverseWordsTool from '../components/tools/stage1/ReverseWordsTool';
import TextStatisticsTool from '../components/tools/stage1/TextStatisticsTool';
import TextToEmojiTool from '../components/tools/stage1/TextToEmojiTool';
import TextWrapperTool from '../components/tools/stage1/TextWrapperTool';
import UnicodeTextTool from '../components/tools/stage1/UnicodeTextTool';
import WordShufflerTool from '../components/tools/stage1/WordShufflerTool';
import AsciiTextTool from '../components/tools/stage1/AsciiTextTool';
import Base64FileEncoderTool from '../components/tools/stage1/Base64FileEncoderTool';
import CodeSnippetGeneratorTool from '../components/tools/stage1/CodeSnippetGeneratorTool';
import CssSelectorTesterTool from '../components/tools/stage1/CssSelectorTesterTool';
import EnvGeneratorTool from '../components/tools/stage1/EnvGeneratorTool';
import HttpHeaderParserTool from '../components/tools/stage1/HttpHeaderParserTool';
import JsonPathTesterTool from '../components/tools/stage1/JsonPathTesterTool';
import MarkdownTableGeneratorTool from '../components/tools/stage1/MarkdownTableGeneratorTool';
import ObjectToJsonTool from '../components/tools/stage1/ObjectToJsonTool';
import RegexLibraryTool from '../components/tools/stage1/RegexLibraryTool';
import SqlToMongoTool from '../components/tools/stage1/SqlToMongoTool';
import AltTextGeneratorTool from '../components/tools/stage1/AltTextGeneratorTool';
import AnchorTextGeneratorTool from '../components/tools/stage1/AnchorTextGeneratorTool';
import BreadcrumbGeneratorTool from '../components/tools/stage1/BreadcrumbGeneratorTool';
import HeadingHierarchyTool from '../components/tools/stage1/HeadingHierarchyTool';
import InternalLinkAnalyzerTool from '../components/tools/stage1/InternalLinkAnalyzerTool';
import PageTitleAnalyzerTool from '../components/tools/stage1/PageTitleAnalyzerTool';
import EmojiPickerTool from '../components/tools/stage1/EmojiPickerTool';
import FakeCompanyGeneratorTool from '../components/tools/stage1/FakeCompanyGeneratorTool';
import FakePhoneGeneratorTool from '../components/tools/stage1/FakePhoneGeneratorTool';
import HashIdGeneratorTool from '../components/tools/stage1/HashIdGeneratorTool';
import HipsumGeneratorTool from '../components/tools/stage1/HipsumGeneratorTool';
import SocialBioGeneratorTool from '../components/tools/stage1/SocialBioGeneratorTool';
import TestimonialGeneratorTool from '../components/tools/stage1/TestimonialGeneratorTool';
import TokenGeneratorTool from '../components/tools/stage1/TokenGeneratorTool';
import BinaryDecimalTool from '../components/tools/stage1/BinaryDecimalTool';
import ColorShadeGeneratorTool from '../components/tools/stage1/ColorShadeGeneratorTool';
import EpochConverterTool from '../components/tools/stage1/EpochConverterTool';
import JsonToUrlParamsTool from '../components/tools/stage1/JsonToUrlParamsTool';
import PercentageCalculatorTool from '../components/tools/stage1/PercentageCalculatorTool';
import TextToSlugTool from '../components/tools/stage1/TextToSlugTool';
import UnitConverterTool from '../components/tools/stage1/UnitConverterTool';

// New Calculator Tools
import CommissionCalculatorTool from '../components/tools/stage1/CommissionCalculatorTool';
import ProfitMarginCalculatorTool from '../components/tools/stage1/ProfitMarginCalculatorTool';
import RoiCalculatorTool from '../components/tools/stage1/RoiCalculatorTool';
import LoanCalculatorTool from '../components/tools/stage1/LoanCalculatorTool';
import MortgageCalculatorTool from '../components/tools/stage1/MortgageCalculatorTool';
import SimpleInterestCalculatorTool from '../components/tools/stage1/SimpleInterestCalculatorTool';
import CompoundInterestCalculatorTool from '../components/tools/stage1/CompoundInterestCalculatorTool';
import CreditCardPayoffCalculatorTool from '../components/tools/stage1/CreditCardPayoffCalculatorTool';
import InvestmentCalculatorTool from '../components/tools/stage1/InvestmentCalculatorTool';
import SavingsCalculatorTool from '../components/tools/stage1/SavingsCalculatorTool';
import InflationCalculatorTool from '../components/tools/stage1/InflationCalculatorTool';
import BreakevenCalculatorTool from '../components/tools/stage1/BreakevenCalculatorTool';
import MarkupCalculatorTool from '../components/tools/stage1/MarkupCalculatorTool';
import DiscountCalculatorTool from '../components/tools/stage1/DiscountCalculatorTool';
import ConversionRateCalculatorTool from '../components/tools/stage1/ConversionRateCalculatorTool';
import CpaCalculatorTool from '../components/tools/stage1/CpaCalculatorTool';
import RoasCalculatorTool from '../components/tools/stage1/RoasCalculatorTool';
import SalaryCalculatorTool from '../components/tools/stage1/SalaryCalculatorTool';
import HourlyToSalaryCalculatorTool from '../components/tools/stage1/HourlyToSalaryCalculatorTool';
import SimpleTaxCalculatorTool from '../components/tools/stage1/SimpleTaxCalculatorTool';
import NetIncomeCalculatorTool from '../components/tools/stage1/NetIncomeCalculatorTool';
import CagrCalculatorTool from '../components/tools/stage1/CagrCalculatorTool';
import InterestCalculatorTool from '../components/tools/stage1/InterestCalculatorTool';
import AmortizationCalculatorTool from '../components/tools/stage1/AmortizationCalculatorTool';
import CpmCalculatorTool from '../components/tools/stage1/CpmCalculatorTool';
import CacCalculatorTool from '../components/tools/stage1/CacCalculatorTool';
import CpcCalculatorTool from '../components/tools/stage1/CpcCalculatorTool';
import CryptoProfitCalculatorTool from '../components/tools/stage1/CryptoProfitCalculatorTool';
import CryptoTaxCalculatorTool from '../components/tools/stage1/CryptoTaxCalculatorTool';
import CryptoRoiCalculatorTool from '../components/tools/stage1/CryptoRoiCalculatorTool';
import BitcoinProfitCalculatorTool from '../components/tools/stage1/BitcoinProfitCalculatorTool';
import EthereumProfitCalculatorTool from '../components/tools/stage1/EthereumProfitCalculatorTool';
import BitcoinRoiCalculatorTool from '../components/tools/stage1/BitcoinRoiCalculatorTool';
import EthereumRoiCalculatorTool from '../components/tools/stage1/EthereumRoiCalculatorTool';
import CryptoInvestmentCalculatorTool from '../components/tools/stage1/CryptoInvestmentCalculatorTool';
import CryptoGainCalculatorTool from '../components/tools/stage1/CryptoGainCalculatorTool';
import SolanaProfitCalculatorTool from '../components/tools/stage1/SolanaProfitCalculatorTool';
import XrpProfitCalculatorTool from '../components/tools/stage1/XrpProfitCalculatorTool';
import LitecoinProfitCalculatorTool from '../components/tools/stage1/LitecoinProfitCalculatorTool';
import DogecoinProfitCalculatorTool from '../components/tools/stage1/DogecoinProfitCalculatorTool';
import CardanoProfitCalculatorTool from '../components/tools/stage1/CardanoProfitCalculatorTool';
import PolygonProfitCalculatorTool from '../components/tools/stage1/PolygonProfitCalculatorTool';

// Registry mapping slug to component
export const toolComponents = {
  // Text Tools
  'text-counter': TextCounterTool,
  'word-counter': WordCounterTool,
  'character-counter': CharacterCounterTool,
  'case-converter': CaseConverterTool,
  'text-reverser': TextReverserTool,
  'text-repeater': TextRepeaterTool,
  'remove-duplicate-lines': RemoveDuplicateLinesTool,
  'sort-lines': SortLinesTool,
  'lorem-ipsum-generator': LoremIpsumTool,
  'diff-checker': DiffCheckerTool,
  'markdown-to-html': MarkdownToHtmlTool,
  'text-to-binary': TextToBinaryTool,
  'find-and-replace': FindAndReplaceTool,
  'extract-emails': ExtractEmailsTool,
  'extract-urls': ExtractUrlsTool,
  'text-cleaner': TextCleanerTool,

  // Developer Tools
  'json-formatter': JsonFormatterTool,
  'json-validator': JsonValidatorTool,
  'regex-tester': RegexTesterTool,
  'html-minifier': HtmlMinifierTool,
  'css-minifier': CssMinifierTool,
  'js-minifier': JsMinifierTool,
  'hash-generator': HashGeneratorTool,
  'timestamp-converter': TimestampConverterTool,
  'json-to-csv': JsonToCsvTool,
  'csv-to-json': CsvToJsonTool,
  'jwt-decoder': JwtDecoderTool,
  'html-to-jsx': HtmlToJsxTool,
  'sql-formatter': SqlFormatterTool,
  'cron-parser': CronParserTool,
  'html-encoder': HtmlEncoderTool,
  'color-converter': ColorPickerTool,

  // SEO Tools
  'meta-tag-generator': MetaTagGeneratorTool,
  'slug-generator': SlugGeneratorTool,
  'url-encoder': UrlEncoderTool,
  'robots-txt-generator': RobotsTxtGeneratorTool,
  'sitemap-generator': SitemapGeneratorTool,
  'keyword-density': KeywordDensityTool,

  // Generators
  'password-generator': PasswordGeneratorTool,
  'uuid-generator': UuidGeneratorTool,
  'placeholder-image': PlaceholderImageTool,
  'qr-code-generator': QrCodeGeneratorTool,
  'random-number': RandomNumberTool,
  'random-string': RandomStringTool,

  // Converters
  'base64-encoder': Base64Tool,
  'color-picker': ColorPickerTool,
  'number-formatter': NumberFormatterTool,
  'hex-to-rgb': HexToRgbTool,
  'rgb-to-hex': HexToRgbTool,
  'px-to-rem': PxToRemTool,
  'rem-to-px': PxToRemTool,
  'celsius-to-fahrenheit': TemperatureConverterTool,
  'fahrenheit-to-celsius': TemperatureConverterTool,
  'bytes-converter': BytesConverterTool,
  'morse-code': MorseCodeTool,
  'roman-numerals': RomanNumeralsTool,

  // Stage 1 Tools (40 new tools)
  // Text Tools
  'line-counter': LineCounterTool,
  'remove-html-tags': RemoveHtmlTagsTool,
  'reverse-words': ReverseWordsTool,
  'text-statistics': TextStatisticsTool,
  'text-to-emoji': TextToEmojiTool,
  'text-wrapper': TextWrapperTool,
  'unicode-text': UnicodeTextTool,
  'word-shuffler': WordShufflerTool,
  'ascii-text': AsciiTextTool,

  // Developer Tools
  'base64-file-encoder': Base64FileEncoderTool,
  'code-snippet-generator': CodeSnippetGeneratorTool,
  'css-selector-tester': CssSelectorTesterTool,
  'env-generator': EnvGeneratorTool,
  'http-header-parser': HttpHeaderParserTool,
  'json-path-tester': JsonPathTesterTool,
  'markdown-table-generator': MarkdownTableGeneratorTool,
  'object-to-json': ObjectToJsonTool,
  'regex-library': RegexLibraryTool,
  'sql-to-mongo': SqlToMongoTool,

  // SEO Tools
  'alt-text-generator': AltTextGeneratorTool,
  'anchor-text-generator': AnchorTextGeneratorTool,
  'breadcrumb-generator': BreadcrumbGeneratorTool,
  'heading-hierarchy': HeadingHierarchyTool,
  'internal-link-analyzer': InternalLinkAnalyzerTool,
  'page-title-analyzer': PageTitleAnalyzerTool,

  // Generators
  'emoji-picker': EmojiPickerTool,
  'fake-company-generator': FakeCompanyGeneratorTool,
  'fake-phone-generator': FakePhoneGeneratorTool,
  'hash-id-generator': HashIdGeneratorTool,
  'hipsum-generator': HipsumGeneratorTool,
  'social-bio-generator': SocialBioGeneratorTool,
  'testimonial-generator': TestimonialGeneratorTool,
  'token-generator': TokenGeneratorTool,

  // Converters
  'binary-decimal': BinaryDecimalTool,
  'color-shade-generator': ColorShadeGeneratorTool,
  'epoch-converter': EpochConverterTool,
  'json-to-url-params': JsonToUrlParamsTool,
  'percentage-calculator': PercentageCalculatorTool,
  'text-to-slug': TextToSlugTool,
  'unit-converter': UnitConverterTool,

  // Calculator Tools
  'commission-calculator': CommissionCalculatorTool,
  'profit-margin-calculator': ProfitMarginCalculatorTool,
  'roi-calculator': RoiCalculatorTool,
  'loan-calculator': LoanCalculatorTool,
  'mortgage-calculator': MortgageCalculatorTool,
  'simple-interest-calculator': SimpleInterestCalculatorTool,
  'compound-interest-calculator': CompoundInterestCalculatorTool,
  'credit-card-payoff-calculator': CreditCardPayoffCalculatorTool,
  'investment-calculator': InvestmentCalculatorTool,
  'savings-calculator': SavingsCalculatorTool,
  'inflation-calculator': InflationCalculatorTool,
  'breakeven-calculator': BreakevenCalculatorTool,
  'markup-calculator': MarkupCalculatorTool,
  'discount-calculator': DiscountCalculatorTool,
  'conversion-rate-calculator': ConversionRateCalculatorTool,
  'cpa-calculator': CpaCalculatorTool,
  'roas-calculator': RoasCalculatorTool,
  'salary-calculator': SalaryCalculatorTool,
  'hourly-to-salary-calculator': HourlyToSalaryCalculatorTool,
  'simple-tax-calculator': SimpleTaxCalculatorTool,
  'net-income-calculator': NetIncomeCalculatorTool,
  'cagr-calculator': CagrCalculatorTool,
  'interest-calculator': InterestCalculatorTool,
  'amortization-calculator': AmortizationCalculatorTool,
  'cpm-calculator': CpmCalculatorTool,
  'cac-calculator': CacCalculatorTool,
  'cpc-calculator': CpcCalculatorTool,
  'crypto-profit-calculator': CryptoProfitCalculatorTool,
  'crypto-tax-calculator': CryptoTaxCalculatorTool,
  'crypto-roi-calculator': CryptoRoiCalculatorTool,
  'bitcoin-profit-calculator': BitcoinProfitCalculatorTool,
  'ethereum-profit-calculator': EthereumProfitCalculatorTool,
  'bitcoin-roi-calculator': BitcoinRoiCalculatorTool,
  'ethereum-roi-calculator': EthereumRoiCalculatorTool,
  'crypto-investment-calculator': CryptoInvestmentCalculatorTool,
  'crypto-gain-calculator': CryptoGainCalculatorTool,
  'solana-profit-calculator': SolanaProfitCalculatorTool,
  'xrp-profit-calculator': XrpProfitCalculatorTool,
  'litecoin-profit-calculator': LitecoinProfitCalculatorTool,
  'dogecoin-profit-calculator': DogecoinProfitCalculatorTool,
  'cardano-profit-calculator': CardanoProfitCalculatorTool,
  'polygon-profit-calculator': PolygonProfitCalculatorTool,
  
  // Tools using Default Component (Coming Soon)
  'add-line-numbers': DefaultToolComponent,
  'api-key-generator': DefaultToolComponent,
  'barcode-generator': DefaultToolComponent,
  'base64-image': DefaultToolComponent,
  'box-shadow-generator': DefaultToolComponent,
  'canonical-url-generator': DefaultToolComponent,
  'code-diff': DefaultToolComponent,
  'color-palette': DefaultToolComponent,
  'credit-card-generator': DefaultToolComponent,
  'crontab-generator': DefaultToolComponent,
  'css-beautifier': DefaultToolComponent,
  'csv-to-table': DefaultToolComponent,
  'date-to-unix': DefaultToolComponent,
  'fake-data-generator': DefaultToolComponent,
  'gitignore-generator': DefaultToolComponent,
  'google-serp-preview': DefaultToolComponent,
  'gradient-generator': DefaultToolComponent,
  'html-beautifier': DefaultToolComponent,
  'html-to-text': DefaultToolComponent,
  'htpasswd-generator': DefaultToolComponent,
  'http-status-codes': DefaultToolComponent,
  'js-beautifier': DefaultToolComponent,
  'json-to-table': DefaultToolComponent,
  'json-to-xml': DefaultToolComponent,
  'json-to-yaml': DefaultToolComponent,
  'km-to-miles': DefaultToolComponent,
  'license-generator': DefaultToolComponent,
  'meta-description-checker': DefaultToolComponent,
  'miles-to-km': DefaultToolComponent,
  'open-graph-generator': DefaultToolComponent,
  'privacy-policy-generator': DefaultToolComponent,
  'readability-checker': DefaultToolComponent,
  'readme-generator': DefaultToolComponent,
  'schema-generator': DefaultToolComponent,
  'string-length': DefaultToolComponent,
  'terms-generator': DefaultToolComponent,
  'text-to-html': DefaultToolComponent,
  'text-to-speech': DefaultToolComponent,
  'title-tag-checker': DefaultToolComponent,
  'truncate-text': DefaultToolComponent,
  'twitter-card-generator': DefaultToolComponent,
  'unix-to-date': DefaultToolComponent,
  'xml-to-json': DefaultToolComponent,
  'yaml-to-json': DefaultToolComponent,
};

// Get tool component by slug
export const getToolComponent = (slug) => {
  return toolComponents[slug] || null;
};

// Check if tool has a component
export const hasToolComponent = (slug) => {
  return slug in toolComponents;
};
